import React from "react";
import { Check, Ticket } from "lucide-react";
import { StickerCard } from "./StickerCard";
import { PillButton } from "./PillButton";
import { TICKET_PACKAGE } from "../../data/mockData";
import { formatIDR } from "../../lib/format";

export function TicketPackageCard({ onBuy, showAllBenefits = true, ctaLabel = "Buy Ticket" }) {
  const p = TICKET_PACKAGE;
  const benefits = showAllBenefits ? p.benefits : p.benefits.slice(0, 6);
  return (
    <StickerCard className="max-w-md w-full mx-auto" data-testid="ticket-package-card">
      <div className="bg-coral text-white text-center py-4 relative">
        <span className="absolute left-4 top-4 bg-white/20 rounded-full px-3 py-1 text-xs font-bold">BEST VALUE</span>
        <p className="font-display text-2xl">{p.name}</p>
        <p className="text-white/85 text-sm font-semibold">1 Orang Tua + 1 Anak</p>
      </div>
      <div className="p-6">
        <div className="text-center">
          <span className="font-display text-4xl text-sea-deep">{formatIDR(p.price)}</span>
          <span className="text-sea-deep/60 font-bold"> {p.perLabel}</span>
        </div>
        <ul className="mt-5 space-y-2.5">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-2 text-sea-deep font-semibold text-sm">
              <span className="mt-0.5 w-5 h-5 rounded-full bg-lime flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-sea-deep" strokeWidth={3} />
              </span>
              {b}
            </li>
          ))}
        </ul>
        <PillButton className="w-full mt-6" size="lg" onClick={onBuy} data-testid="ticket-buy-button">
          <Ticket className="w-5 h-5" /> {ctaLabel}
        </PillButton>
        <p className="text-center text-xs text-sea-deep/50 mt-3 font-semibold">*Terms &amp; Conditions apply.</p>
      </div>
    </StickerCard>
  );
}
